import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import PropTypes from "prop-types";
import { NODE_API_URL, BASE_URL } from "../../../env_config";
import Cookies from "js-cookie";
import axios from "axios";
import { Chip, makeStyles, Tab, Tabs, Typography } from "@material-ui/core";
import { IoSettingsOutline } from "react-icons/io5";
import { ApiDataTable } from "../DiamondFeedNew/ApiDataTable/APIDataTable";
import { GoDotFill } from "react-icons/go";
import { toast } from "react-toastify";
import { SwalWarn } from "../Popup";
import { OrderHistoryDetail } from "../DiamondFeedNew/OrderHistory/OrderHistoryDetail";

function TabContainer(props) {
    return (
        <Typography component="div" style={{ padding: 8 * 3 }}>
            {props.children}
        </Typography>
    );
}

TabContainer.propTypes = {
    children: PropTypes.node.isRequired,
};

export const ShopifyRulePage = (props) => {
    const [tab, setTab] = useState(0);

    const handleTabChange = (event, newValue) => {
        setTab(newValue);
    };

    const testMode = props.customeriframeorapi.api_test_mode;
    const liveMode = props.customeriframeorapi.api_live_mode;

    let currentStatus = "none";
    if (testMode === "ON") {
        currentStatus = "test";
    } else if (liveMode === 1 && testMode !== "ON") {
        currentStatus = "live";
    } else if (liveMode === 0 && testMode !== "ON") {
        currentStatus = "none";
    }

    const useStyles = makeStyles((theme) => ({
        container: {
            display: "flex",
            [theme.breakpoints.up("xs")]: {
                flexDirection: "column",
                alignItems: "end",
                gap: theme.spacing(1),
            },
            [theme.breakpoints.up("md")]: {
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
            },
        },
        rootLive: {
            borderColor:
                currentStatus === "live"
                    ? "#209524"
                    : currentStatus === "test"
                    ? "#ff9500"
                    : "#808080",
            color:
                currentStatus === "live"
                    ? "#209524"
                    : currentStatus === "test"
                    ? "#ff9500"
                    : "#808080",
        },
        iconLive: {
            color:
                currentStatus === "live"
                    ? "#209524"
                    : currentStatus === "test"
                    ? "#ff9500"
                    : "#808080",
            fontSize: "0.75rem",
        },
        labelLive: {
            fontWeight: 500,
            textTransform: "none",
        },
    }));

    const classes = useStyles();

    const history = useHistory();
    const [currencyvalue, setCurrencyValue] = useState("");
    const [supplieron, setSupplierOn] = useState(null);

    const [loading, setLoading] = useState(false);
    const [swalopen, setSwalOpen] = useState({
        open: false,
        message: "",
        okFunction: null,
    });

    useEffect(() => {
        setCurrencyValue(props.customeriframeorapi.api_currency);
        axios({
            method: "POST",
            url: `${NODE_API_URL}/INTL/fetch-supplier-step`,
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${Cookies.get("cust_auth_token")}`,
            },
            data: {
                api_id: props.customeriframeorapi.api_id,
            },
        })
            .then((supreq) => {
                if (supreq && supreq.data) {
                    if (supreq.data !== "Please Turn On Suppliers") {
                        setSupplierOn(supreq.data);
                    }
                }
            })
            .catch((error) => {
                if (error?.response?.data?.message === "UnAuthorized!") {
                    var cookies = document.cookie.split(";");
                    for (var i = 0; i < cookies.length; i++) {
                        if (cookies[i] && !cookies[i].includes("view")) {
                            var equals = cookies[i].indexOf("=");
                            var name =
                                equals > -1
                                    ? cookies[i].substr(0, equals)
                                    : cookies[i];
                            document.cookie =
                                name +
                                "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
                        }
                    }

                    window.location.replace(`${BASE_URL}/logout`);
                }
            });
    }, [props.customerapi, props.customeriframeorapi]);

    function handleTestModeToggle(checked) {
        setLoading(true);
        axios({
            method: "POST",
            url: `${NODE_API_URL}/INTL/manage-test-token`,
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${Cookies.get("cust_auth_token")}`,
            },
            data: {
                testMode: checked,
            },
        })
            .then((res) => {
                if (res.data.success) {
                    toast.dismiss();
                    toast.success(
                        `Test mode is now ${
                            checked ? "enabled" : "disabled"
                        }...`
                    );
                    props.setUpdateData((prev) => !prev);
                }
            })
            .catch((error) => {
                if (error?.response?.data?.message === "UnAuthorized!") {
                    var cookies = document.cookie.split(";");
                    for (var i = 0; i < cookies.length; i++) {
                        if (cookies[i] && !cookies[i].includes("view")) {
                            var equals = cookies[i].indexOf("=");
                            var name =
                                equals > -1
                                    ? cookies[i].substr(0, equals)
                                    : cookies[i];
                            document.cookie =
                                name +
                                "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
                        }
                    }

                    window.location.replace(`${BASE_URL}/logout`);
                } else if (error?.response?.data?.message) {
                    toast.dismiss();
                    toast.warning(error?.response?.data?.message);
                }
            })
            .finally(() => {
                setLoading(false);
                setSwalOpen(false);
            });
    }

    return (
        <div className="card shadow-none card-custom">
            <div className="card-header">
                <h3 className="card-title">
                    Shopify App Dashboard{" "}
                    {props.customeriframeorapi.feed_type ===
                    "SHOPIFY APP RING" ? (
                        <Chip
                            className="ml-2"
                            size="small"
                            color="primary"
                            label="BETA"
                            disabled
                            variant="outlined"
                        />
                    ) : (
                        ""
                    )}
                </h3>
                <div className="card-toolbar d-flex align-items-center">
                    <div className="d-flex align-items-center mr-3">
                        <span
                            className="mr-3"
                            style={{ textTransform: "capitalize" }}
                        >
                            {currentStatus === "live"
                                ? "Enable Test Mode"
                                : currentStatus === "test"
                                ? "Disable Test Mode"
                                : "Enable test Mode"}
                        </span>
                        <label className="switch mr-3" style={{ margin: "0" }}>
                            <input
                                type="checkbox"
                                className="success"
                                disabled={loading}
                                checked={
                                    props.customeriframeorapi?.api_test_mode ===
                                    "ON"
                                }
                                onChange={(event) => {
                                    const checked = event.target.checked;
                                    setSwalOpen({
                                        open: true,
                                        message: `Are You Sure You Want ${
                                            checked ? "Enable" : "Disable"
                                        } Test Mode?`,
                                        okFunction: () =>
                                            handleTestModeToggle(checked),
                                    });
                                }}
                            />
                            <span className="slider" />
                        </label>
                        <Chip
                            variant="outlined"
                            size="small"
                            icon={<GoDotFill />}
                            label={
                                currentStatus === "live"
                                    ? "Live Mode"
                                    : currentStatus === "test"
                                    ? "Test Mode"
                                    : "Test Mode"
                            }
                            color="primary"
                            classes={{
                                root: classes.rootLive,
                                icon: classes.iconLive,
                                label: classes.labelLive,
                            }}
                        />
                    </div>
                    <div className="card-toolbar d-flex align-items-center">
                        <button
                            className="btn btn-text-dark btn-hover-light-dark"
                            onClick={() =>
                                history.push({
                                    pathname: "/shopify-app-setting",
                                })
                            }
                        >
                            <IoSettingsOutline className="mr-2" />
                            {props.language.DIAMOND_FEED_SHOPIFY_APP_SETTING}
                        </button>
                    </div>
                </div>
            </div>
            <div className={`col-12 px-0 border-bottom ${classes.container}`}>
                <Tabs
                    variant="scrollable"
                    value={tab}
                    onChange={handleTabChange}
                >
                    <Tab label="Mark-up rules Manager" />
                    <Tab label="Order History" />
                </Tabs>
            </div>
            {tab === 0 ? (
                <div className="col-12 pt-3">
                    <ApiDataTable
                        userinfo={props.userinfo}
                        language={props.language}
                        customerapi={props.customerapi}
                        setUpdateData={props.setUpdateData}
                        updatedata={props.updatedata}
                        currencyvalue={currencyvalue}
                        supplieron={supplieron}
                        loader={props.loader}
                        setCustomerAPI={props.setCustomerAPI}
                        customeriframeorapi={props.customeriframeorapi}
                    />
                </div>
            ) : (
                ""
            )}
            {tab === 1 ? (
                <div className="col-12 pt-3">
                    <OrderHistoryDetail
                        userinfo={props.userinfo}
                        language={props.language}
                    />
                </div>
            ) : (
                ""
            )}
            <SwalWarn
                show={swalopen.open}
                message={swalopen.message}
                onHide={() => setSwalOpen((prev) => ({ ...prev, open: false }))}
                onClose={() =>
                    setSwalOpen((prev) => ({ ...prev, open: false }))
                }
                responseOnOk={swalopen.okFunction}
            />
        </div>
    );
};
